import { render } from "./BillingDetails.vue?vue&type=template&id=33ec2d64"
import script from "./BillingDetails.vue?vue&type=script&lang=js"
export * from "./BillingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__